import { Page } from '../../Components/Page';
import { useTabbedNav } from '../../utils/hooks/useNav';
import { CompanyExperiments } from './CompanyExperiments';
import { ExperimentFlags } from './ExperimentFlags';
import { UserExperiments } from './UserExperiments';
import { UserGroups } from './UserGroups';

const PageTab = {
  USER_EXPERIMENTS: 'user-experiments',
  COMPANY_EXPERIMENTS: 'company-experiments',
  USER_GROUPS: 'user-groups',
  EXPERIMENT_FLAGS: 'experiment-flags'
} as const;
type PageTabType = (typeof PageTab)[keyof typeof PageTab];

const NAVS = [
  { label: 'User Experiments', key: PageTab.USER_EXPERIMENTS },
  { label: 'Company Experiments', key: PageTab.COMPANY_EXPERIMENTS },
  { label: 'User Groups', key: PageTab.USER_GROUPS },
  { label: 'Experiment Flags', key: PageTab.EXPERIMENT_FLAGS }
];

export const FeatureExperiments = () => {
  const { tab, goToTab } = useTabbedNav<PageTabType>({
    baseURL: 'feature-experiments',
    defaultKey: PageTab.USER_EXPERIMENTS,
    navs: NAVS.map(nav => nav.key)
  });

  const tabContent = (() => {
    switch (tab) {
      case PageTab.USER_EXPERIMENTS:
        return <UserExperiments />;
      case PageTab.COMPANY_EXPERIMENTS:
        return <CompanyExperiments />;
      case PageTab.USER_GROUPS:
        return <UserGroups />;
      case PageTab.EXPERIMENT_FLAGS:
        return <ExperimentFlags />;
      default:
        return null;
    }
  })();

  return (
    <Page
      navs={NAVS}
      onNav={nav => goToTab(nav as PageTabType)}
      pageType='Feature Experiments'
      selectedNav={tab}
      title='Feature Experiments'
    >
      {tabContent}
    </Page>
  );
};
